<template>
  <b-container fluid>
    <PortalNavbar></PortalNavbar>
    <b-container style="background-color: #e8eff9">
      <div class="mx-5" style="layout-grid: 18pt">
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><font face="Mangal"
              >पुणे जिल्हा सुरक्षा रक्षक मंडळ पुणे</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><font face="Mangal"
              >सुरक्षा रक्षक समुच्चय पुल निकाल-२०१९</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><font face="Mangal">आरक्षण निहाय कट ऑफ गुण</font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><font face="Mangal"
              >मंडळाच्या समुच्चय पुलावर घेण्यासाठी पात्र / योग्य ठरलेल्या
              उमेदवारांच्या गुणांचा आरक्षणनिहाय तपशील (कट ऑफ) पुढीलप्रमाणे</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><font face="Calibri">.</font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 12pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <div align="center">
          <table
            class="MsoNormalTable"
            border="0"
            cellspacing="0"
            style="
              border-collapse: collapse;
              width: 279pt;
              border: none;
              mso-padding-alt: 0pt 5.4pt 0pt 5.4pt;
            "
          >
            <tr style="height: 22.8pt">
              <td
                width="68"
                valign="bottom"
                rowspan="2"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: 1pt solid rgb(0, 0, 0);
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: bottom"
                >
                  <b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        >अनु. क्र.</span
                      ></u
                    ></b
                  ><b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        ><o:p></o:p></span></u
                  ></b>
                </p>
              </td>
              <td
                width="253"
                valign="bottom"
                rowspan="2"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: 1pt solid rgb(0, 0, 0);
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: bottom"
                >
                  <b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        >आरक्षण प्रवर्ग</span
                      ></u
                    ></b
                  ><b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        ><o:p></o:p></span></u
                  ></b>
                </p>
              </td>
              <td
                width="143"
                valign="top"
                colspan="2"
                style="
                  width: 86.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: 1pt solid rgb(0, 0, 0);
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <b
                    ><u
                      ><span
                        class="16"
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        >कट-ऑफ गुण</span
                      ></u
                    ></b
                  ><b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        ><o:p></o:p></span></u
                  ></b>
                </p>
              </td>
            </tr>
            <tr style="height: 22.8pt">
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        >महिला</span
                      ></u
                    ></b
                  ><b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        ><o:p></o:p></span></u
                  ></b>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: 1pt solid rgb(0, 0, 0);
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        >पुरुष</span
                      ></u
                    ></b
                  ><b
                    ><u
                      ><span
                        style="
                          font-family: Mangal;
                          color: rgb(0, 0, 0);
                          font-weight: bold;
                          text-decoration: underline;
                          text-underline: single;
                          font-size: 11pt;
                        "
                        ><o:p></o:p></span></u
                  ></b>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >१</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >खुलागट</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;</span
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >OPEN)</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >३९</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >२</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >अनुसूचित जाती</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="mso-spacerun: 'yes'">&nbsp;</span>(SC)</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३६</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >अनुसूचित जमाती</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="mso-spacerun: 'yes'">&nbsp;</span>(ST)</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३६</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >४</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >विमुक्त जाती</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="mso-spacerun: 'yes'">&nbsp;</span>(</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">अ</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >)</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;</span
                    ><font face="Mangal">DT (A)</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३७</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >५</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >भटक्या जमाती</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;</span
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">ब</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">) NT (</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >B</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">)</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३७</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >६</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >धनगर व तत्सम</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;</span
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">क</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">) NT (C)</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३७</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >७</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >वंजारी</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;</span
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">ड</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal"
                      >)
                      <span style="font-family: Mangal; mso-spacerun: 'yes'"
                        >&nbsp;</span
                      >NT (D)</font
                    ></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३७</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >८</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >इतर मागासवर्गीय</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="font-family: Mangal; mso-spacerun: 'yes'"
                      >&nbsp;&nbsp;</span
                    ></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >OBC</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">)</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३७</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
            <tr style="height: 27pt">
              <td
                width="68"
                valign="center"
                style="
                  width: 40.8pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: 1pt solid rgb(0, 0, 0);
                  mso-border-left-alt: 0.5pt solid rgb(0, 0, 0);
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: middle"
                >
                  <span
                    class="17"
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >९</span
                  ><span
                    class="18"
                    style="
                      font-family: Calibri;
                      mso-fareast-font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >.</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="253"
                valign="top"
                style="
                  width: 152.05pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p class="MsoNormal" style="vertical-align: top">
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >विशेष मागास प्रवर्ग</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><span style="mso-spacerun: 'yes'">&nbsp;&nbsp;</span></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">(</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >SBC</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><font face="Mangal">)</font></span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="63"
                valign="top"
                style="
                  width: 38.15pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    >२१</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 12pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
              <td
                width="80"
                valign="top"
                style="
                  width: 48pt;
                  padding: 0pt 5.4pt 0pt 5.4pt;
                  border-left: none;
                  mso-border-left-alt: none;
                  border-right: 1pt solid rgb(0, 0, 0);
                  mso-border-right-alt: 0.5pt solid rgb(0, 0, 0);
                  border-top: none;
                  mso-border-top-alt: 0.5pt solid rgb(0, 0, 0);
                  border-bottom: 1pt solid rgb(0, 0, 0);
                  mso-border-bottom-alt: 0.5pt solid rgb(0, 0, 0);
                "
              >
                <p
                  class="MsoNormal"
                  align="center"
                  style="text-align: center; vertical-align: top"
                >
                  <span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    >३६</span
                  ><span
                    style="
                      font-family: Mangal;
                      color: rgb(0, 0, 0);
                      font-size: 11pt;
                    "
                    ><o:p></o:p
                  ></span>
                </p>
              </td>
            </tr>
          </table>
        </div>
        <p class="MsoNormal" align="center" style="text-align: center">
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p class="MsoNormal">
          <b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              ><font face="Mangal">उमेदवारांना</font></span
            ></b
          ><b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              >&nbsp;</span
            ></b
          ><b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              ><font face="Mangal">सूचना</font></span
            ></b
          ><b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              >&nbsp;<font face="Calibri">:</font></span
            ></b
          ><b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              ><o:p></o:p></span
          ></b>
        </p>
        <p class="MsoNormal">
          <b
            ><span
              style="
                mso-spacerun: 'yes';
                font-family: Calibri;
                mso-fareast-font-family: SimSun;
                mso-bidi-font-family: Mangal;
                font-weight: bold;
                font-size: 11pt;
              "
              ><o:p>&nbsp;</o:p></span
            ></b
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >१. उपरोक्त प्रमाणे समुच्चय पुलावर घेण्यासाठी पात्र ठरलेल्या सर्व
              उमेदवारांना त्यांनी त्यांचा अर्जात केलेल्या दाव्याच्या अनुषंगाने
              त्यांची पात्रता तपासण्याच्या आधीन राहून सुरक्षा रक्षक म्हणून
              मंडळात नोंदीत करून समुच्यय पुलावर घेण्याबाबतचा निर्णय घेण्यात
              येईल.
            </font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >२. शारिरीक/ मैदानी परीक्षा प्राप्त गुण व शैक्षणिक गुण यांची बेरीज
              करून आलेल्या एकूण गुणांच्या आधारे, वरील प्रमाणे आरक्षण
              प्रवर्गानुसार कट ऑफ गुण जाहीर करण्यात आले आहेत. उमेदवाराना सूचना
              करण्यात येते की ज्या उमेदवारांना त्यांच्या आरक्षण प्रवर्गा नुसार
              कट ऑफ गुणा एवढे वा जास्त गुण असतील त्यांना पुढील प्रक्रियेकरिता
              त्यांच्या नोंदीत भ्रमणध्वनी (Mobile) वर SMS पाठविण्यात येतील.
            </font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >३. पात्र उमेदवारांना वैद्यकीय व चारित्र्य प्रमाणपत्राचे नमूने
              यांच्या वैयक्तिक login नुसार https://sgbregistration.in या
              पोर्टलवर १ एप्रिल २०२२ रोजी उपलब्ध करून दिले जातील.</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >४. पात्र उमेदवारांनी स्वत:चे वैद्यकीय व चारित्र्य प्रमाणपत्र
              दिनांक ३० एप्रिल २०२२ पर्यन्त https://sgbregistration.in या पोर्टल वर
              जमा (upload) करावीत.</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >५. वैद्यकीय व चारित्र्य प्रमाणपत्राच्या प्रत्यक्ष पडताळणीनंतर
              पात्र उमेदवारांनी B-Form साठी ऑनलाइन रु. १०० व इतर कर भरल्यानंतर
              मंडळाच्या प्रतीक्षा यादी वर सामील करून घेतले जाईल.</font
            ></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >६. सदरचा निकाल म्हणजे कामाची हमी नसून विविध अस्थापना / फँक्टरी
              यांच्याकडून प्राप्त मागणीनुसार समुच्चय पूलातील नोंदीत सुरक्षा
              रक्षकांना काम उपलब्ध करून देण्यात येईल.
            </font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p>&nbsp;</o:p></span
          >
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal"
              >७. पुणे जिल्हा सुरक्षा रक्षक मंडळ, पुणे. सूमुच्चय पुल निकाल २०१९ हा मंडळाने शासनास दिंनाक १२-०२-२०२१ रोजीच्या पत्राद्वारे प्रवर्ग निहाय आरक्षणाबाबत मागितलेल्या मार्गदर्शनाच्या अधीन राहून जाहीर करण्यात येत आहे.
            </font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
        <p
          class="MsoNormal"
          align="justify"
          style="
            margin-right: -24.7pt;
            mso-para-margin-right: -2.47gd;
            text-align: justify;
            text-justify: inter-ideograph;
            margin-top: 10pt;
          "
        >
          <span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><font face="Mangal">आदेशानुसार <br> २९ मार्च २०२२ </font></span
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: Calibri;
              mso-fareast-font-family: SimSun;
              mso-bidi-font-family: Mangal;
              font-size: 11pt;
            "
            ><o:p></o:p
          ></span>
        </p>
      </div>
    </b-container>
  </b-container>
</template>
<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
  components: {
    PortalNavbar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PuneNotice.vue